export default [
  { label: 'Primero de cada mes', value: 'P' },
  { label: 'Último día del mes', value: 'U' },
  { label: 'Otro día del mes', value: 'otro' },
];
